import React from "react";
import { useScrollPartition } from "../../hooks/useScrollPartition";
import { IconButton } from "@mui/material";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";

export const ScrollTopButton = () => {
    const partition = useScrollPartition(1500, 1800);
    return (
        partition > 0 && (
            <IconButton
                onClick={() => {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }}
                style={{ opacity: partition }}
                className="shadow-standard fixed bottom-[96px] md:bottom-[48px] right-[16px] z-[200] h-[36px] w-[36px] rounded-full bg-sh-red md:right-[24px] md:h-[50px] md:w-[50px]"
            >
                <ArrowUpwardOutlinedIcon sx={{ color: "white" }} />
            </IconButton>
        )
    );
};
